import { create } from "zustand";

import { Workspace } from "@/types/power-editor.types";

type RecoveryNotice = NonNullable<Workspace["recoveryNotice"]>;

interface RecoveryNoticeState {
  projectId: string | null;
  notice: RecoveryNotice | null;
  setNotice: (projectId: string, notice: RecoveryNotice) => void;
  clear: () => void;
}

/**
 * Bridges the project-scoped recovery notice (discovered by the PowerEditor
 * route from the workspace DTO) up to the dashboard layout's attention area,
 * so the banner renders in the same top slot as Maintenance/Announcement/
 * Billing banners instead of inside the editor pane.
 */
export const useRecoveryNoticeStore = create<RecoveryNoticeState>((set) => ({
  projectId: null,
  notice: null,
  setNotice: (projectId, notice) => set({ projectId, notice }),
  clear: () => set({ projectId: null, notice: null }),
}));
